import React, { useState, useCallback, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import { getValueStringMapForEditors } from '../editors/EditorStringValueUtils';
import { Tooltip } from '@material-ui/core';
// import './CategoryAsEditor.less'
import { compareEditorChildren } from './../utils/ProviderNodeUtils';

interface ICategoryAsEditorProps {
  node: ContextProviderNode;
  children?: React.ReactNode;
}

const getClassName = () => classNames('dp-category-as-editor');

/**
 * Display string value for category when rendering it as though it were a popup editor.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function CategoryAsEditor({ node, children }: ICategoryAsEditorProps) {
  const [values, setValues] = useState(new Map<string, string>());
  const [valueString, setValueString] = useState(node.Node.Name);
  const editors = node.Children.sort(compareEditorChildren);
  const updateValue = useCallback(async () => {
    const map = await getValueStringMapForEditors(editors);
    const str = Array.from(map.values()).join(', ');
    setValues(map);
    setValueString(str);
  }, [editors]);

  useEffect(() => {
    updateValue();
  }, [updateValue]);

  const tooltip = useMemo(
    () => (
      <ul>
        {Array.from(values).map(([key, val]) => (
          <li key={key}>
            <b>{key}: </b>
            {val}
          </li>
        ))}
      </ul>
    ),
    [values]
  );

  return (
    <Tooltip title={tooltip} arrow={true}>
      <div className={getClassName()}>
        <label className="dp-category-as-editor__value dpc-field-label__text">{valueString}</label>
        {children}
      </div>
    </Tooltip>
  );
}
